import { NavigationButtons } from "@/components/NavigationButtons"
import { routes } from "@/navigation"
import { ConfigSlimStep } from "@/types/configuration"
import { ConsentItem } from "@/types/typesInterfaces"
import { addClassToAnchorTags } from "@/utils/functions"
import { SetStateAction } from "react"

interface Props {
    texts: any
    consentsCatalogue: any

    consentStates: ConsentItem[]
    handleConsentChange(index: number): void
}

const PrivacyComponent = ({ texts, consentsCatalogue, consentStates, handleConsentChange }: Props) => {
    return <div className="w-full flex flex-col gap-4">
        {
            consentsCatalogue?.map((consent, index: number) => (
                <div className="" key={consent.consentCode}>
                    <label className="flex flex-rows gap-4 w-full">
                        <div className="flex justify-start items-center">

                            <input type="checkbox" className="accent-primaryBlue700 h-6 w-6"
                                checked={consentStates[index]?.accepted || false}
                                onChange={() => handleConsentChange(index)}
                            />
                        </div>
                        <div className="text-left flex items-center">
                            <small className="" dangerouslySetInnerHTML={{ __html: addClassToAnchorTags(consent.consentContent[0].body) }}></small>
                        </div>
                    </label>
                </div>
            ))
        }
    </div>
}

export default PrivacyComponent;
